module.exports = __webpack_public_path__ + "assets/img/615b437009d56a215c9a3d163b0a5030.png";